<path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M17.8571 42L0 25.175L5 20.465L17.8571 32.575L45 7L50 11.71L17.8571 42Z"
    fill="currentColor"
/>
